import { render, staticRenderFns } from "./TrxnHistoryTable.vue?vue&type=template&id=59394fed&"
import script from "./TrxnHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./TrxnHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./TrxnHistoryTable.vue?vue&type=style&index=0&id=59394fed&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports